import { Component } from '@angular/core';

@Component({
  template: '<h2 style="text-align: center;margin-top: 15%;">You do not have permission to view this page.</h2>'
})
export class UnauthorisedComponent {}
